import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Dollar",
  "use": "Dollar-usage",
  "viewBox": "0 0 12 20",
  "content": "<symbol viewBox=\"0 0 12 20\" id=\"Dollar\"><path d=\"M6.089 8.778c-2.522-.656-3.333-1.334-3.333-2.39 0-1.21 1.122-2.055 3-2.055 1.977 0 2.71.945 2.777 2.334h2.456C10.91 4.756 9.744 3 7.422 2.433V0H4.09v2.4C1.933 2.867.2 4.267.2 6.411.2 8.978 2.322 10.256 5.422 11c2.778.667 3.334 1.644 3.334 2.678 0 .766-.545 1.989-3 1.989-2.29 0-3.19-1.023-3.312-2.334H0c.133 2.434 1.956 3.8 4.089 4.256V20h3.333v-2.389c2.167-.411 3.89-1.667 3.89-3.944 0-3.156-2.7-4.234-5.223-4.89z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol